import { createMuiTheme, theme } from '@c6bank/diamond'

const defaultTheme = createMuiTheme({
  ...theme,
})

export default defaultTheme
